// extracted by mini-css-extract-plugin
export default {"container":"OrganisationsUsersPage_container__UomrJ","loaderContainer":"OrganisationsUsersPage_loaderContainer__vZVk0"};